const Coin = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6.65723C7.03 6.65723 2 8.20323 2 11.1572V15.1572C2 18.1112 7.03 19.6572 12 19.6572C16.97 19.6572 22 18.1112 22 15.1572V11.1572C22 8.20323 16.97 6.65723 12 6.65723ZM4 15.1572V13.9602C4.63334 14.3189 5.30399 14.6073 6 14.8202V16.7012C4.688 16.1872 4 15.5752 4 15.1572ZM16 15.3052V17.2762C15.133 17.4552 14.133 17.5862 13 17.6342V15.6342C14.0064 15.5942 15.0088 15.4842 16 15.3052ZM11 17.6352C9.99201 17.5966 8.98877 17.4769 8 17.2772V15.3062C8.959 15.4802 9.972 15.5932 11 15.6362V17.6352ZM18 16.7012V14.8202C18.6962 14.6077 19.3669 14.3193 20 13.9602V15.1572C20 15.5752 19.313 16.1872 18 16.7012ZM12 13.6572C6.823 13.6572 4 12.0062 4 11.1572C4 10.3082 6.823 8.65723 12 8.65723C17.177 8.65723 20 10.3082 20 11.1572C20 12.0062 17.177 13.6572 12 13.6572Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Coin;
